import { render } from "./remixIcon.vue?vue&type=template&id=b4579644&scoped=true"
import script from "./remixIcon.vue?vue&type=script&lang=js"
export * from "./remixIcon.vue?vue&type=script&lang=js"

import "./remixIcon.vue?vue&type=style&index=0&id=b4579644&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4579644"],['__file',"src/views/vab/icon/remixIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b4579644"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b4579644', __exports__)) {
    console.log('reload')
    api.reload('b4579644', __exports__)
  }
  
  module.hot.accept("./remixIcon.vue?vue&type=template&id=b4579644&scoped=true", () => {
    console.log('re-render')
    api.rerender('b4579644', render)
  })

}


export default __exports__